import React from 'react';
import { Workflow, type LucideProps } from 'lucide-react';

export type AgentGlyphProps = LucideProps;

export const AgentGlyph = React.forwardRef<SVGSVGElement, AgentGlyphProps>(
  ({ className, ...props }, ref) => (
    <Workflow
      ref={ref}
      aria-hidden="true"
      focusable="false"
      className={className}
      {...props}
    />
  ),
);

AgentGlyph.displayName = 'AgentGlyph';
